module.exports = __webpack_public_path__ + "img/germini.1f20887f.jpg";